
import { IFieldForm } from "pages/read-documents/model/IFieldForm";
import { IOptionsDropdowns } from "shared/models";

export const fieldsFormAutorizations = (optionsDropdowns: IOptionsDropdowns): IFieldForm[]  => {
    return [
        {
            id: 'invoiceDateService',
            name: 'invoiceDateService',
            type: 'datePicker',
            label: 'Fecha de prestación de servicio de la factura',
            placeholder: '',
            testId: 'invoiceDateService',
            isEnable: true
        },
        {
            id: 'itemFormAuthorizedBy',
            name: 'authorizationValue',
            type: 'Autocomplete',
            label: 'Auditor que autoriza',
            placeholder: 'Auditor que autoriza',
            testId: 'itemFormAuthorizedBy',
            isEnable: true,
            options: optionsDropdowns?.users
        },
        {
            id: 'itemFormPaymentLine',
            name: 'paymentLine',
            type: 'Select',
            label: 'Linea de pago',
            placeholder: 'Linea de pago',
            testId: 'itemFormPaymentLine',
            isEnable: true,
            options: optionsDropdowns?.paymentsLines
        },
        {
            id: 'itemFormState',
            name: 'stateInvoice',
            type: 'modal',
            label: 'Estado de factura',
            placeholder: 'Estado de factura',
            testId: 'itemFormState',
            isEnable: true,
        },
        {
            id: 'itemFormInvoiceReference',
            name: 'invoiceReference',
            type: 'text',
            label: 'Factura de referencia',
            placeholder: 'Factura de referencia',
            testId: 'itemFormInvoiceReference',
            isEnable: true
        },
        {
            id: 'itemformNit',
            name: 'nitEntidad',
            type: 'text',
            label: 'Nit',
            placeholder: 'Ingrese nit',
            testId: 'itemformNit',
            isEnable: true
        },
        {
            id: 'itemformRadicado',
            name: 'radicado',
            type: 'text',
            label: 'Radicado',
            placeholder: 'Radicado',
            testId: 'itemformRadicado',
            isEnable: true
        },
        {
            id: 'radicadoAt',
            name: 'radicadoAt',
            type: 'datePicker',
            label: 'Fecha de radicación',
            placeholder: 'Fecha de radicación',
            testId: 'radicadoAt',
            isEnable: true
        },
    ]
}